module.exports = {
          srcSet: __webpack_public_path__ + "2bf9ef484f3f677f561bf1f6ea4fc1e8-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "2bf9ef484f3f677f561bf1f6ea4fc1e8-60.png",width: 60,height: 72}],
          src: __webpack_public_path__ + "2bf9ef484f3f677f561bf1f6ea4fc1e8-60.png",
          toString:function(){return __webpack_public_path__ + "2bf9ef484f3f677f561bf1f6ea4fc1e8-60.png"},
          
          width: 60,
          height: 72
        }